module.exports = require("brace");


//////////////////
// WEBPACK FOOTER
// external "brace"
// module id = 421
// module chunks = 0